import getList from './../../repository/history';

const state = {
  historyList: null,
  dialogVisibility: false,
  activeListItem: null,
  singleUser: null,
  postsPerPage: 50,
  totalPages: null,
  query: null,
  dirAccess: [],
};

const getters = {
  historyList: store => store.historyList,
  postsPerPage: store => store.postsPerPage,
  query: store => store.query,
  totalPages: store => store.totalPages,
};

const mutations = {
  SET_USERS_LIST(state, historyList) {
    state.historyList = historyList;
  },
  SET_TOTAL_PAGES(state, pages) {
    state.totalPages = pages;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
};

const actions = {
  setQuery({ commit }, query) {
    commit('SET_QUERY', query);
  },
  async getUsersList({ commit, state }, page) {
    const currentPage = page || 1;
    const query = {
      ...state.query,
    };
    const params = {
      page: currentPage,
      length: state.postsPerPage,
      ...query,
    };
    commit('SET_USERS_LIST', null);
    let historyList = await getList(params);
    historyList = historyList.data.data;
    const { totalPages, items } = historyList;
    commit('SET_USERS_LIST', items);
    commit('SET_TOTAL_PAGES', totalPages);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
